export namespace ColumnsUtils {
  type Inputs = {
    availableWidth: number;
    nbOfColumns: number;
    spaceBetween: number;
    spaceAround: [number, number];
  };

  export type ColumnsResult = {
    size: (n: number) => number;
    position: (n: number) => number;
    nbOfColumns: number;
    spaceBetween: number;
  };

  export const getColumns = ({ availableWidth, nbOfColumns, spaceBetween, spaceAround }: Inputs): ColumnsResult => {
    const realAvailableSize = availableWidth - spaceAround[0] - spaceAround[1];
    const allColumnsSize = realAvailableSize - (nbOfColumns - 1) * spaceBetween;
    const columnSize = Math.floor(allColumnsSize / nbOfColumns);
    const rest = allColumnsSize - columnSize * nbOfColumns;
    const restLeft = Math.floor(rest / 2);
    const size = (n: number) => (n === 0 ? 0 : n * columnSize + (n - 1) * spaceBetween);
    return {
      size,
      position: (n: number) => spaceAround[0] + restLeft + size(n) + (n > 0 ? spaceBetween : 0),
      nbOfColumns,
      spaceBetween,
    };
  };
}



// WEBPACK FOOTER //
// ./src/module/Common/utils/ColumnsUtils.ts